/** Up to three integer and four decimal digits of a percent: "8.875", "20", "0.5". */
export const PERCENT = /^\d{1,3}(\.\d{1,4})?$/;

/**
 * Percent text to the fraction the API stores. Scaled through integers so "8.875" becomes
 * exactly 0.08875 instead of 0.08875000000000001.
 */
export function percentToFraction(percent: string): number {
  return Math.round(Number(percent) * 10_000) / 1_000_000;
}

export function fractionToPercent(fraction: number): number {
  return Math.round(fraction * 1_000_000) / 10_000;
}

export function isPercent(value: string): boolean {
  return PERCENT.test(value) && Number(value) <= 100;
}
